var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLivejournal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00afed",
  d: "M1.844 6.21 0 4.369A8.4 8.4 0 0 1 4.347 0l1.841 1.839.001.001a8.384 8.384 0 1 1-5.056 7.695 8.3 8.3 0 0 1 .71-3.323l6.82 6.806h-.001a8.41 8.41 0 0 1 4.343-4.369h.001L6.19 1.843l-.003-.001a8.4 8.4 0 0 0-4.343 4.369zm11.649 4.764a4.9 4.9 0 0 0-2.523 2.537l3.184.659z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#13374d",
  d: "M8.662 13.018a8.41 8.41 0 0 1 4.343-4.369h.001L6.19 1.843l-.003-.001a8.4 8.4 0 0 0-4.344 4.37zm4.831-2.044a4.9 4.9 0 0 0-2.523 2.537l3.184.659-.66-3.196z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.493 10.975-.487-2.325h-.002a8.42 8.42 0 0 0-4.342 4.368l2.308.493a4.92 4.92 0 0 1 2.523-2.536"
}))));
export default SvgLivejournal;